export enum CostCenterEnums {
  TipoTercero = 1,
  TipoAdministración = 2,
  TipoPropio = 3,

  Todos = 1,
  CcoMonedaDiferente = 0,

  CCostosTodos = 0,
  CCostosSoloActivos = 1,
  CCostosActivosSusp = 2
}